<template>
  <body>
  </body>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {}
    },
    created() {

    },
    mounted() {
      let access_token = this.$route.query.access_token
      let lang_type = this.$route.query.lang_type

      console.log('access_token === ' + access_token)
      console.log('lang_type === ' + lang_type)

      this.tokenLogin(access_token, lang_type)
    },
    methods: {
      tokenLogin(access_token, langType) {
        this.$axios.get('/api/sso/tokenlogin', {
          params: {
            "access_token": access_token,
            "lang_type": langType
          }
        })
          .then(response => {
            console.log('超级登录接口数据返回')
            console.log(response)
            let code = response.code
            let data = response.data
            let message = response.msg
            if (code == '0') {
              if (langType == 'CN') {
                localStorage.setItem('locale', 'zh')
              } else {
                localStorage.setItem('locale', 'en')
              }
              this.$router.push({
                name: "personaloverview"
              })
            } else if (code == '-1') {
              this.$message.error(message)
            }
          })
          .catch(error => {
            console.log(error);
            this.abnormalSituation()
          });
      }

    },
    components: {}
  }
</script>
